import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useApptekster } from '../contexts/ApptekstContext';
import { SVVSpinner } from '@komponentkassen/svv-spinner';
import { SVVCheckboxGroup } from '@komponentkassen/svv-form';
import { SVVButton, SVVButtonRow } from '@komponentkassen/svv-button';

type GodtaVilkarTekstProps = {
    handlingsknapp: string;
    avbrytKnapp: () => void;
    bekreftelseslabel: string;
    bekreftelsestekst: string;
    onSubmit: () => void;
    laster: boolean;
};

export const GodtaVilkarSkjema: React.FC<GodtaVilkarTekstProps> = ({
    handlingsknapp,
    bekreftelseslabel,
    bekreftelsestekst,
    onSubmit,
    laster,
    avbrytKnapp,
}) => {
    const t = useApptekster();
    const { handleSubmit } = useForm();
    const [valgtVilkar, setValgtVilkar] = useState(false);
    const [feilmelding, setFeilmelding] = useState('');
    return (
        <form
            noValidate
            onSubmit={handleSubmit(() => {
                if (!valgtVilkar) {
                    setFeilmelding(
                        t(
                            'personlig-kjennemerke.soknad.feilmelding.godtavilkar',
                        ),
                    );
                } else {
                    onSubmit();
                }
            })}
        >
            <div className="spacing-bottom--medium" data-hj-suppress={true}>
                <SVVCheckboxGroup
                    legend={bekreftelseslabel}
                    required
                    error={feilmelding}
                    id='godta-vilkar-sjekkbokser'
                    options={[
                        {
                            id: 'godtaVilkar',
                            label: bekreftelsestekst,
                            onChange: (event) => {
                                setFeilmelding('');
                                setValgtVilkar(event.target.checked);
                            },
                            checked: valgtVilkar,
                        },
                    ]}
                />
            </div>

            <div aria-live="polite">
                {laster && (
                    <SVVSpinner size="small" centered={false}>
                        {t('personlig-kjennemerke.delt.laster')}
                    </SVVSpinner>
                )}
            </div>
            {!laster && (
                <SVVButtonRow>
                    <SVVButton type="submit">{handlingsknapp}</SVVButton>
                    <SVVButton onClick={avbrytKnapp} color="secondary">
                        {t('personlig-kjennemerke.delt.avbryt')}
                    </SVVButton>
                </SVVButtonRow>
            )}
        </form>
    );
};
